import { useState } from "react";
import Modal from "../ui/uiElements/Modal.component";
import alertService from "../services/alert.service";
import { alertsConfig } from "../utils/alertsUtils";
import ConfigTable from "../ui/ConfigTable.component";
import { Alert, Button, Form } from "react-bootstrap";

import "../ui/styles/configPage.css";
import FormRow from "../ui/uiElements/FromRow.component";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";

function ConfigPage() {
  const [days, setdays] = useState(10);
  const [toDate, setToDate] = useState();
  const [fromDate, setFromDate] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [tickerInfo, setTickerInfo] = useState([]);
  const [configedAlerts, setConfigedAlerts] = useState([]);
  const [errors, setErrors] = useState([]);

  const itemsPerPage = localStorage.getItem("paginationConfig");

  const { register, handleSubmit, formState } = useForm({
    defaultValues: !itemsPerPage ? 50 : { itemsPerPage },
  });

  const { errors: formErrors } = formState;

  const onSubmit = (data) => {
    localStorage.setItem("paginationConfig", data.itemsPerPage);
    toast.success("Pagination setting changed");
  };

  const handleSubmitByDays = async (days) => {
    if (!days) {
      const defaultDays = 10;
      setdays(defaultDays);
    }
    setIsLoading(true);
    const res = await alertService.getTickersByDate(days);
    setTickerInfo(res);
    setIsLoading(false);
    setConfigedAlerts(alertsConfig(res));
  };

  const handleSubmitByRange = async (days) => {
    if (!toDate) {
      const defaultToDate = new Date();
      setToDate(defaultToDate.toISOString().split("T")[0]);
    }
    setIsLoading(true);
    const res = await alertService.getTickersByRange(fromDate, toDate);
    setTickerInfo(res);
    setIsLoading(false);
    setConfigedAlerts(alertsConfig(res));
  };

  const onChangeHandler = (e) => {
    setdays(e.target.value);
    if (e.target.value > 0) {
      setErrors([]);
    }
    if (e.target.value <= 0) {
      setErrors(["Invalid value , Please enter a valid value ..."]);
      return;
    }
  };

  return (
    <>
      <div className="config-container mt-5  bg-light p-4 m-auto shadow bg-body-tertiary rounded">
        {errors.length !== 0 && <Alert variant="danger">{errors[0]}</Alert>}
        <div className="config-days">
          <label className=" form-label" htmlFor="date">
            Information About Tickers Last :
          </label>
          <div className="input-group">
            <input
              className=" form-control "
              name="date"
              type="number"
              onChange={(e) => onChangeHandler(e)}
              value={days}
            />
            <span className="input-group-text" id="basic-addon2">
              days
            </span>
          </div>
          <Modal>
            <Modal.Open opens="alertsConfig" onSubmit={() => handleSubmitByDays(days)}>
              <button type="submit" disabled={errors.length !== 0} className="btn btn-info fs-6 right-90">
                Submit
              </button>
            </Modal.Open>
            <Modal.Window name="alertsConfig">
              <ConfigTable
                alertsNumber={tickerInfo.length}
                configedAlerts={configedAlerts}
                days={days}
                isLoading={isLoading}
              />
            </Modal.Window>
          </Modal>
        </div>
      </div>
      <div className="config-container mt-5 bg-light p-4 m-auto shadow bg-body-tertiary rounded">
        <div className=" d-flex flex-column  gap-3">
          <h5>Config Alerts With date range</h5>
          <div className="row mb-3">
            <label className="col-sm-3  col-form-label" htmlFor="startDate">
              From:
            </label>
            <div className="col-sm-8">
              <input
                className="form-control w-100 "
                onChange={(e) => setFromDate(e.target.value)}
                id="startDate"
                type="date"
              />
            </div>
          </div>
          <div className="row mb-3">
            <label className="col-sm-3  col-form-label" htmlFor="endDate">
              to:
            </label>
            <div className="col-sm-8">
              <input
                className="form-control w-100 "
                onChange={(e) => setToDate(e.target.value)}
                id="endDate"
                type="date"
                defaultValue={toDate}
              />
            </div>
          </div>

          <Modal>
            <Modal.Open opens="alertsConfig" onSubmit={() => handleSubmitByRange(days)}>
              <button type="submit" className="btn btn-info fs-6 right-90  float-end">
                Submit
              </button>
            </Modal.Open>
            <Modal.Window name="alertsConfig">
              <ConfigTable
                from={fromDate}
                to={toDate}
                alertsNumber={tickerInfo.length}
                configedAlerts={configedAlerts}
                isLoading={isLoading}
              />
            </Modal.Window>
          </Modal>
        </div>
      </div>
      <div className="config-container mt-5  bg-light p-4 m-auto shadow bg-body-tertiary rounded mb-5">
        <h5 className="text-center">Pagination setting</h5>
        <hr />
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormRow label="Number of items per page" error={formErrors?.itemsPerPage?.message}>
            <Form.Control
              type="number"
              id="itemsPerPage"
              placeholder="Number of items per page"
              {...register("itemsPerPage", {
                required: "This field is required",
                valueAsNumber: true,
              })}
            />
          </FormRow>
          <button type="submit" className="btn btn-info fs-6 right-90">
            Submit
          </button>
        </form>
      </div>
    </>
  );
}

export default ConfigPage;
